export const OmniStyles = {
    tableCell: { border: "none", fontSize: "17px", py: 0.5 },
    answercell: { border: "none", fontSize: "17px", py: 0.5 },
    listStyle: {
        display: "flex",
        flexDirection: window.innerWidth <= 750 ? "column" : "row",
        marginBottom: "8px",
    }
}